import { PopulatedCampaignUserDtoStatusEnum } from '@coretava/api/ecommerce-service';
import { Campaign } from '@gamiphy/loyalty-station-desktop/components/cashback/campaigns';
import CampaignUser from '@gamiphy/loyalty-station-desktop/components/cashback/campaigns/CampaignUser';
import {
  BirthdayGiftCard,
} from '@gamiphy/loyalty-station-desktop/components/cashback/cashbackProgram/loggedIn/components/birthdayGift';
import {
  CashbackDetails,
} from '@gamiphy/loyalty-station-desktop/components/cashback/cashbackProgram/loggedIn/components/cashbackDetails';
import {
  DemoReferral,
} from '@gamiphy/loyalty-station-desktop/components/cashback/cashbackProgram/loggedIn/components/demoReferral';
import { SignupPopup } from '@gamiphy/loyalty-station-desktop/components/cashback/signup';
import { AppCashbackStore } from '@gamiphy/loyalty-station-desktop/store/appCashback';
import { AppWelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/appWelcomeGift';
import { BirthdayGiftStore } from '@gamiphy/loyalty-station-desktop/store/birthdayGift';
import { CampaignUserStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers';
import { DiscountsStore } from '@gamiphy/loyalty-station-desktop/store/discounts';
import { LevelStore } from '@gamiphy/loyalty-station-desktop/store/level';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import {
  LevelsTab,
  WelcomeGiftTab,
} from '@gamiphy/loyalty-station-desktop/tabs';
import { Stack } from '@mui/material';
import { useFlag } from '@unleash/proxy-client-react';
import { observer } from 'mobx-react';
import React from 'react';

const Home: React.FC = () => {
  const demoFeaturesEnabled = useFlag('core-loyalty-demo');

  const showWelcomeGift = React.useMemo(
    () => (AppWelcomeGiftStore.welcomeGift?.enabled && (!UserStore.user?.phone ||
      DiscountsStore.isWelcomeGiftDiscountValid)),
    [
      AppWelcomeGiftStore.welcomeGift,
      UserStore.user,
      DiscountsStore.isWelcomeGiftDiscountValid,
    ],
  );
  React.useEffect(() => {
    if (!AppCashbackStore.currentAppCashback?.enabled &&
      !CampaignUserStore.campaignUsers?.length &&
      !BirthdayGiftStore.showBirthdayGift &&
      !LevelStore.tierConfig?.enabled &&
      !DiscountsStore.isWelcomeGiftDiscountValid && (!AppWelcomeGiftStore.welcomeGift?.enabled || !!DiscountsStore.welcomeGiftDiscount) &&
      !demoFeaturesEnabled) {
      UiStore.hide();
    } else {
      UiStore.show();
    }
  }, [AppCashbackStore.currentAppCashback?.enabled,
    CampaignUserStore.campaignUsers,
    BirthdayGiftStore.showBirthdayGift,
    LevelStore.tierConfig?.enabled,
    AppWelcomeGiftStore.welcomeGift?.enabled,
    DiscountsStore.isWelcomeGiftDiscountValid,
    DiscountsStore.welcomeGiftDiscount,
    demoFeaturesEnabled]);

  return (
    <Stack
      flex={1}
      p={1}
      spacing={1}
    >
      {
        AppCashbackStore.currentAppCashback?.enabled && (
          <CashbackDetails />
        )
      }
      {UserStore.isLoggedIn ? (
        CampaignUserStore.campaignUsers?.map((camUser) => (
          <CampaignUser
            key={camUser.id}
            campaignUser={camUser}
          />
        ))
      ) : (
        CampaignUserStore.campaigns?.map((campaign) => (
          <Campaign
            key={campaign.id}
            campaign={campaign}
            status={PopulatedCampaignUserDtoStatusEnum.Pending}
          />
        ))
      )}
      {
          BirthdayGiftStore.showBirthdayGift && (
          <BirthdayGiftCard />
          )
        }
      {
        LevelStore.tierConfig?.enabled && (
          <LevelsTab />
        )
      }
      {
          showWelcomeGift && (
            <WelcomeGiftTab />
          )
      }
      {
        demoFeaturesEnabled && (
        <DemoReferral />
        )
      }
      <SignupPopup open={UiStore.signupPopupOpen} />
    </Stack>
  );
};

export default observer(Home);
